// extracted by mini-css-extract-plugin
export default {"posts":"Projects_posts__8gk1d"};